<template>
  <div class="container-fluid max-container consultation">
    <div class="row">
      <Header />
      <section>
        <div class="container">
          <div class="archaic-upgrade-container-fluid">
            <!-- BreadCrumb component starts here -->
            <nav class="mt-4" style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item" aria-current="page">
                  <router-link :to="{ name: 'dashboard' }">Home</router-link>
                </li>
                <li class="breadcrumb-item" aria-current="page">
                  <router-link :to="{ name: 'bloodTest' }">Blood Test</router-link>
                </li>
                <li class="breadcrumb-item active">Book A Consultation
                </li>
              </ol>
            </nav>
            <div class="prev-button is-mobile">
              <router-link :to="{ name: 'bloodTest' }">
                <img src="@/assets/images/back-arrow.svg" />
                <span>Back</span>
              </router-link>
            </div>
            <!-- BreadCrumb Component ends here -->

            <!-- 70 30 row col starts here -->
            <div class="row">
              <div class="col-lg-7">
                <div class="consultation-container">
                  <img :src="HealthGeneticsImage" alt="" />
                  <div class="content-consultation">
                    <h1>Book a private 1-1 consultation</h1>
                    <p>
                      Would you like to discuss your blood test report with one of our
                      expert doctors? Book a 20-minute or 30-minute telephone consultation
                      so that you can better understand your results and how you can
                      optimise your health, at a time that suits your schedule.
                    </p>
                    <h2>What’s included</h2>
                    <p>
                      A variety of appointment times are available to you, and prior to
                      booking you will receive a short survey asking what you would like
                      to discuss and basic information surrounding your health status,
                      which will be reviewed by the doctor ahead of the appointment
                      allowing you to make the most out of your consultation.
                    </p>
                    <p>
                      During the consultation you will be able to ask the doctor any
                      questions about your health test results, such as:
                    </p>
                    <ul>
                      <li>What your results mean</li>
                      <li>
                        What further tests are recommended, or how frequently you should
                        repeat the test
                      </li>
                      <li>How your symptoms could be related to your results</li>
                      <li>How lifestyle changes could improve your health and results</li>
                      <li>
                        Why there could be an upwards or downwards trend in your results
                        over time
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-lg-5">
                <div class="form-consultation-container">
                  <form @submit.prevent="requestConsultation">
                    <div>
                      <label for="">First name</label><br />
                      <input type="text" v-model="appointmentDetails.firstName" />
                    </div>
                    <div>
                      <label for="">Last name</label><br />
                      <input type="text" v-model="appointmentDetails.lastName" />
                    </div>
                    <div>
                      <label for="">Phone Number</label><br />
                      <input type="text" v-model="appointmentDetails.phone" />
                    </div>
                    <div>
                      <label for="">Briefly explain your reason for a health consultation</label><br />

                      <textarea name="" id="" cols="10" v-model="appointmentDetails.appointmentInfo"></textarea>
                    </div>

                    <div class="consultation-cta">
                      <button>Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- 70 30 row col ends here -->
          </div>
        </div>
      </section>
    </div>
    <ModalView :title="''" :isVisible="isModalOpen" @close="closeModal" :isConsultation="true">
      <ConsultationModal @close="closeModal" />
    </ModalView>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { usePatientStore } from "@/store/health/blood";
import Header from "@/components/header/Header.vue";
import "../../../styles/pages/bookConsultation.scss";
import HealthGeneticsImage from "../../../assets/images/Health/healthGenetics.png";
import ConsultationModal from "./Modal/ConsultationModal.vue";
import ModalView from "@/components/Modal/ModalView.vue";

const patientStore = usePatientStore();
const errorMessage = ref("");
const saveStatus = ref("idle");
const isModalOpen = ref(false);

const appointmentDetails = ref({
  firstName: patientStore.patient.firstName,
  lastName: patientStore.patient.lastName,
  phone: patientStore.patient.phone,
  appointmentInfo: "",
});
function closeModal() {
  isModalOpen.value = false;
}
async function requestConsultation() {
  saveStatus.value = "saving";
  patientStore
    .editPatient({
      firstName: appointmentDetails.value.firstName,
      lastName: appointmentDetails.value.lastName,
      phone: appointmentDetails.value.phone,
      appointmentInfo: appointmentDetails.value.appointmentInfo,
    })
    .then(() => (saveStatus.value = "completed"))
    .catch(() => (errorMessage.value = "Something went wrong"));
  isModalOpen.value = true;
  // .finally(() => ());
}
</script>
<style lang="scss">
.consultation {
  .alert-modal {
    border-color: #6cae29;
    width: 470px;
  }
}
</style>